import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NextLivingNodeSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2
          className="text-lg md:text-xl text-foreground-800 mb-2 text-center"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t('journey.nextLivingNode.title')}
          <span className="block text-xs text-foreground-400 font-normal mt-1">
            {t('journey.nextLivingNode.titleEn')}
          </span>
        </h2>

        {/* Observe → Reflect → Practice → Reveal flow */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 mt-8 max-w-2xl mx-auto">
          {/* Observe */}
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-foreground-100 flex items-center justify-center mb-2">
              <i className="ri-eye-line text-foreground-500 text-lg" />
            </div>
            <p className="text-sm font-medium text-foreground-600">
              {t('journey.nextLivingNode.observe')}
            </p>
            <p className="text-[10px] text-foreground-400">
              {t('journey.nextLivingNode.observeEn')}
            </p>
          </div>

          <div className="text-foreground-300 hidden sm:block">→</div>
          <div className="text-foreground-300 sm:hidden">↓</div>

          {/* Reflect */}
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-foreground-100 flex items-center justify-center mb-2">
              <i className="ri-pause-circle-line text-foreground-500 text-lg" />
            </div>
            <p className="text-sm font-medium text-foreground-600">
              {t('journey.nextLivingNode.reflect')}
            </p>
            <p className="text-[10px] text-foreground-400">
              {t('journey.nextLivingNode.reflectEn')}
            </p>
          </div>

          <div className="text-foreground-300 hidden sm:block">→</div>
          <div className="text-foreground-300 sm:hidden">↓</div>

          {/* Practice */}
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-foreground-100 flex items-center justify-center mb-2">
              <i className="ri-riding-line text-foreground-500 text-lg" />
            </div>
            <p className="text-sm font-medium text-foreground-600">
              {t('journey.nextLivingNode.practice')}
            </p>
            <p className="text-[10px] text-foreground-400">
              {t('journey.nextLivingNode.practiceEn')}
            </p>
          </div>

          <div className="text-foreground-300 hidden sm:block">→</div>
          <div className="text-foreground-300 sm:hidden">↓</div>

          {/* Reveal — hidden/shimmer */}
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-accent-50 border border-accent-200/50 flex items-center justify-center mb-2 relative">
              <i className="ri-sparkling-line text-accent-300 text-lg" />
              <div className="absolute inset-0 rounded-full bg-accent-100/30 animate-pulse" />
            </div>
            <p className="text-sm font-medium text-foreground-600">
              {t('journey.nextLivingNode.reveal')}
            </p>
            <p className="text-[10px] text-foreground-400">
              {t('journey.nextLivingNode.revealEn')}
            </p>
          </div>
        </div>

        {/* Hint card + CTA */}
        <div className="max-w-md mx-auto mt-8 bg-background-100 border border-foreground-200/40 rounded-xl p-5 text-center">
          <i className="ri-lightbulb-flash-line text-amber-400 text-xl mb-2 inline-block" />
          <p className="text-xs text-foreground-500 leading-relaxed mb-1">
            {t('journey.nextLivingNode.hint')}
          </p>
          <p className="text-sm text-foreground-700 italic mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
            {t('journey.nextLivingNode.teaser')}
          </p>
          <Link
            to="/living-node"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-compass-3-line" />
            進入當下生命節點
          </Link>
        </div>
      </div>
    </section>
  );
}